import React, { useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import useDidMount from '../../hooks/useDidMount'
import useImmerState from '../../hooks/useImmerState'
import styles from './style.module.scss'
import ScrollHide from './util'

interface linkItem {
    name: string,
    path: string
}

interface Props {
    list: Array<linkItem>
}

interface State {
    scrollTop?: Number,
    offsetY?: Number,
    scrollHide?: ScrollHide
}

const Navigator = (props: Props) => {
    const path = useLocation().pathname;
    const nav = useRef(null);
    const [state, setState] = useImmerState({
        scollTop: 0,
        offsetY: 0,
        scroll: undefined
    });
    useEffect(() => {
        console.log(path);
        const app = document.getElementById("App");
        if (app != null) {
            app.onscroll = (e) => {
                setState((state: State) => {
                    state.scrollTop = app.scrollTop;
                })
            }
            setState((state: State) => {
                state.scrollHide = new ScrollHide(app, nav.current)
            })
            return () => {
                state.scrollHide.unmount()
            }
        }

    }, [])
    return (
        <div ref={nav} className={styles.navigator} style={{ backgroundColor: state.scrollTop <= state.offsetY ? 'white' : 'white' }}>
            <div>
                <Link to="/">
                    <img className={styles.logo} src={require('../../assets/png/logo.png')} alt="illumina" />
                </Link>
                <ul className={styles.menu}>
                    {
                        props.list.map((item, i) => (
                            <li key={props.list.indexOf(item)}>
                                <Link className={path === item.path ? styles.active : ''} to={item.path} >
                                    {item.name}
                                </Link>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </div>
    )
}



export default Navigator;